module.exports = __webpack_public_path__ + "static/img/banner-3.ee1a7f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/advantage/banner-3.png
// module id = j0LC
// module chunks = 1